const dataLayerFilterSubmit = (
  event?: string,
  filterCategory?: string,
  filterSelected?: string,
) => {
  window.dataLayer = window.dataLayer || [];
  if (!event) return {};
  const gtmData = {
    event,
    ...(filterCategory && { filterCategory }),
    ...(filterSelected && { filterSelected }),
  };
  return window.dataLayer.push(gtmData);
};

export default dataLayerFilterSubmit;
